import { createContext, useContext } from 'react';

import type { StrippingFertilizationResponse } from '@/services/stripping/types';

const StrippingContext = createContext<{
  selectedRow: StrippingFertilizationResponse | undefined;
  setSelectedRow: React.Dispatch<
    React.SetStateAction<StrippingFertilizationResponse | undefined>
  >;
  refetchFertilizations: () => void;
  qcStripperTipLotNumber: string;
  setQcStripperTipLotNumber: React.Dispatch<React.SetStateAction<string>>;
} | null>(null);

// eslint-disable-next-line react-refresh/only-export-components
export function useStrippingContext() {
  const context = useContext(StrippingContext);

  if (!context) {
    throw new Error(
      'Stripping.* component must be rendered as child of Stripping component',
    );
  }

  return context;
}

export default StrippingContext;
